import React from 'react';

import {FormikErrors, withFormik} from 'formik';

import {Utils, Constants} from 'commons';
import PropTypes, {InferProps} from 'prop-types';
import {ResetPasswordValues} from 'commons/models';
import InnerFormPassword from './InnerFormPassword';

PasswordForm.propTypes = {
    submitHandler: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
};
const FormControl = withFormik<InferProps<typeof PasswordForm.propTypes>, ResetPasswordValues>({
    mapPropsToValues: () => {
        return {
            token: '',
            newPassword: '',
            passwordConfirmed: '',
        };
    },
    validateOnBlur: true,
    validateOnChange: true,
    validate: (values: ResetPasswordValues) => {
        const errors: FormikErrors<ResetPasswordValues> = {};
        if (!values.newPassword) {
            errors.newPassword = Utils.messageFunctions.getRequiredMessage('Nueva contrase\u00F1a');
        } else {
            if (!Constants.Regex.PASSWORD.test(values.newPassword)) {
                errors.newPassword = 'Error de formato';
            } else if (values.newPassword != values.passwordConfirmed) {
                errors.passwordConfirmed = 'Las contrase\u00F1as no coinciden';
            }
        }
        if (!values.passwordConfirmed) {
            errors.passwordConfirmed = Utils.messageFunctions.getRequiredMessage(
                'Confirmar nueva contrase\u00F1a'
            );
        }
        return errors;
    },
    handleSubmit: async (values, actions) => {
        actions.setSubmitting(false);
        await actions.props.submitHandler(values);
    },
})(InnerFormPassword);

function PasswordForm(props: InferProps<typeof PasswordForm.propTypes>) {
    const {submitHandler, isLoading} = props;
    return <FormControl submitHandler={submitHandler} isLoading={isLoading} />;
}

export default PasswordForm;
